import React, { useState } from 'react';
import { collapsedLabel } from '../domain/safety';
import { Button } from '@/components/ui/button';
import { EyeOff } from 'lucide-react';

/**
 * A comment or group message from someone with a block either way with me
 * (017 FR-012, FR-013, FR-017): "Blocked comment" / "Blocked message" and a
 * Show button. Showing lasts while it's on screen; nothing remembers it.
 * `actions` stay available without revealing (e.g. Report).
 */
export default function CollapsedItem({
  kind,
  children,
  actions,
}: {
  kind: 'comment' | 'message';
  children: React.ReactNode;
  actions?: React.ReactNode;
}) {
  const [shown, setShown] = useState(false);
  if (shown) return <>{children}</>;

  const label = collapsedLabel(kind);
  return (
    <div
      role="group"
      aria-label={`${label}, collapsed`}
      className="flex items-center gap-3 rounded-2xl bg-muted px-4 py-2 text-sm text-muted-foreground"
    >
      <EyeOff className="size-4 shrink-0" aria-hidden="true" />
      <span className="flex-1 italic">{label}</span>
      <Button
        variant="ghost"
        size="sm"
        className="rounded-full text-primary"
        onClick={() => setShown(true)}
      >
        Show
      </Button>
      {actions}
    </div>
  );
}
